import React from 'react';
import { Box } from '@chakra-ui/react';
import ContactFooter from './contact-footer';

function Footer() {
  return (
    <Box className="Footer">
      <ContactFooter />
    </Box>
  );
}

export default Footer;
